
  var $ = jQuery = $;

$(document).ready(function() {
    collectionAccordion();
});

function collectionAccordion() {
    $('.template-collection .boost-pfs-filter-option-title').each(function() {
        $(this)
            .parent('.boost-pfs-filter-option')
            .addClass('boost-pfs-filter-option-collapsed');
    });


    $(document).on('click', '.template-collection .boost-pfs-filter-option-title', function() {
        $(this)
          .parent('.boost-pfs-filter-option')
          .toggleClass('boost-pfs-filter-option-collapsed')
          .find('.boost-pfs-filter-option-content')
          .stop()
          .slideToggle(300);
    });
}

// iWish Add to cart
const iWishForms = document.querySelectorAll('.iwish-product-form');
if (iWishForms) {
  iWishForms.forEach((iWishForm) => {
    const iWishButton = iWishForm.querySelector('.iwishBuyBtn');
    const productID = iWishForm.querySelector("input[name='id']").value;
    if (iWishForm) {
      iWishButton.addEventListener('click', (event) => {
        event.preventDefault();
        let formData = {
          'items': [{
            'id': productID,
            'quantity': 1
            }]
          };
        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        })
        .then(response => {
          return response.json();
        })
        .then(() => {
          document.documentElement.dispatchEvent(new CustomEvent('theme:cartchanged', { bubbles: true, cancelable: false, detail: { openDrawer: true } }));
        })
        .catch((error) => {
          console.error('Error:', error);
        });
      });
    }
  });
}


const readMoreContainer = document.querySelector('.template-collection .reading-width');

if (readMoreContainer && readMoreContainer.offsetHeight > 25) {
    // Read more functionality in collections description { Collections page }
    const readMoreWrapper = document.createElement('div');
    const readmoreLink = document.createElement('a');
    const containerHeight = readMoreContainer.offsetHeight;

    readmoreLink.textContent = 'read more';
    readmoreLink.classList.add('hb-collection-btn-readmore', 'js-collection-header-readmore');

    readMoreWrapper.classList.add('hb-collection-desc-accordion-container');
    readMoreWrapper.style.height = '75px';

    readMoreContainer.parentNode.insertBefore(readmoreLink, readMoreContainer.nextSibling);
    readMoreContainer.parentNode.insertBefore(readMoreWrapper, readMoreContainer);
    readMoreWrapper.append(readMoreContainer);

    readmoreLink.addEventListener('click', () => {
        readMoreWrapper.classList.toggle('hb-collection-desc-accordion-container--active');
        if (readMoreWrapper.classList.contains('hb-collection-desc-accordion-container--active')) {
            readMoreWrapper.style.height = containerHeight + 'px';
            readmoreLink.textContent = 'read less';
        } else {
            readMoreWrapper.style.height = '25px';
            readmoreLink.textContent = 'read more';
        }
    });
}

// Collection Swatch
const fetchSwatch = (collectionId, swatchContainer) => {
  const storefrontAccessToken = theme.settings.swatches_api;
  const storefrontDomain = 'homebodii-uat.myshopify.com';

  fetch(`https://${storefrontDomain}/api/2023-04/graphql.json`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': storefrontAccessToken
    },
    body: JSON.stringify({
      query: `
        query {
          node(id: "${collectionId}") {
            ... on Collection {
              products(first: 99) {
                edges {
                  node {
                    id,
                    handle,
                    title,
                    swatch_image: metafield(namespace: "custom", key: "swatch_image") {
                      reference {
                        ... on MediaImage {
                          image {
                            originalSrc
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      `
    })
  })
    .then(response => response.json())
    .then(data => {
      let products = data.data.node.products.edges;
      for (product in products) {
        const swatchHandle = products[product].node.handle;
        let swatchColor = products[product].node.title;
        let productID = products[product].node.id;
        let swatchImage = "";
        let class_custom = "";
        
        var current_color = document.querySelector('#current_color').getAttribute('data-current');
        swatchColor = swatchColor.slice(swatchColor.indexOf(" - ") + 3);

        swatchHandelize = swatchColor.replace(/ /g, "-");
        // debugger;
        if(current_color === swatchHandelize){
          class_custom = 'current';
        }
        productID = productID.replace("gid://shopify/Product/", "");

        // Custom image
        if (products[product].node.swatch_image != null && products[product].node.swatch_image != undefined) {
          let swatchImageSrc = products[product].node.swatch_image.reference.image.originalSrc;
          swatchImage = `style="background-image: url(${swatchImageSrc}) !important;"`;
        } else {
          swatchImage = `style="background-color: ${swatchColor};"`;
        }
        
        swatchContainer.innerHTML += `<div class="custom-swatch__item ${class_custom} custom-swatch--${productID} custom-swatch__item--${swatchHandelize.toLowerCase()}" ${swatchImage}><a href="/products/${swatchHandle}" title="${swatchColor}" class="quickbuy-toggle">${swatchColor}</a></div>`;
      }
    })
    .catch(error => console.error(error));
}

let swatchContainer = document.querySelectorAll('.js-custom-swatch');
if (swatchContainer.length) {
  swatchContainer.forEach((swatch) => {
    const collectionID = swatch.dataset.collectionId;
    fetchSwatch(collectionID, swatch);
    // debugger;
  });
}

const changePreOrderText = (position) => {
  const preOrderField = document.querySelector('#properties-pre-order');
  if (preOrderField != undefined && preOrderField) {
    preOrderField.value = "";
    if (position !== '' && variantPreOrderText[position] !== '' && variantPreOrderText[position] !== undefined) {
      preOrderField.value = variantPreOrderText[position];
    }
  }
}

const backOrderContents = document.querySelectorAll('.js-backorder-copy');
const hideBackToOrderPDP = () => {
  if (backOrderContents.length) {
    backOrderContents.forEach((backOrderContent) => {
      backOrderContent.style.display = "none";
    });
  }
}
const showBackToOrderPDP = (position) => {
  const thisText = document.querySelector('.js-backorder-copy.backorder-copy--' + position);
  if (thisText !== null) {
    thisText.style.display = "block";
  }
}
const showHideAddToCart = (addToCartButton, notifyWhenAvailButton, selectedVariant) => {
  if (addToCartButton !== undefined && addToCartButton !== null && notifyWhenAvailButton !== undefined && notifyWhenAvailButton !== null) {
    console.log(selectedVariant, selectedVariant.classList.contains('is-unavailable'));
    if (selectedVariant.classList.contains('is-unavailable')) {
      addToCartButton.style.display = 'none'
    } else {
      addToCartButton.style.display = 'block'
    }
  }
}
const variantButtons = document.querySelectorAll('.js-variant-button');
const addToCartButton = document.querySelector('.js-add-to-cart-button');
const notifyWhenAvailButton = document.querySelector('.klaviyo-bis-trigger');

if (backOrderContents.length) {
  hideBackToOrderPDP();
}
if (variantButtons.length) {
  variantButtons.forEach((variantButton) => {
    if (variantButton.getAttribute('checked') !== null) {
      showBackToOrderPDP(variantButton.dataset.variantPosition);
      changePreOrderText(variantButton.dataset.variantPosition);
      setTimeout(() => {
        showHideAddToCart(addToCartButton, notifyWhenAvailButton, variantButton);
      }, 1000);
    }
    variantButton.addEventListener('change', (event) => {
      changePreOrderText(event.target.dataset.variantPosition);
      showHideAddToCart(addToCartButton, notifyWhenAvailButton, event.target);
      if (addToCartButton.dataset.preOrder == 1) {
        setTimeout(() => {
          hideBackToOrderPDP();
          showBackToOrderPDP(event.target.dataset.variantPosition);
          if (variantStock[event.target.dataset.variantPosition] <= 0) {
            addToCartButton.innerHTML = theme.strings.products_product_pre_order;
          } else {
            addToCartButton.innerHTML = theme.strings.products_product_add_to_cart;
          }
        }, 100);
      }
    });
  })
}

/**
 * Initialises a button that updates the product form's properties with the relevant availability text.
 * This is currently used for product page 'AddToCart' or 'Add Personalisation' buttons for HOM-3.
 * @param {HTMLElement} button 
 * @param {HTMLElement|null} [form] - Optional, will just use document.querySelector() if no param passed in
 */
const initPropertiesChangeToButton = (button, form) => {

  if (!button) {
    console.warn('No button passed in to initPropertiesChangeToButton')
    return
  }

  const queryElem = form ? form : document

  button.addEventListener("click", () => {
    // Availability section
    const deliveryAvailabilityText = queryElem.querySelector('.js-availability');
    const pickUpAvailabilityText = queryElem.querySelector('.store-availability-information__title');
    const deliveryProp = queryElem.querySelector('.js-prop-delivery-availability');
    const pickupProp = queryElem.querySelector('.js-prop-pickup-availability');
    
    if (deliveryAvailabilityText !== null && deliveryAvailabilityText !== undefined && pickUpAvailabilityText !== null && pickUpAvailabilityText !== undefined) {
      deliveryProp.value = deliveryAvailabilityText.innerText.trim();
      pickupProp.value = pickUpAvailabilityText.innerText.trim();
    }
  });
}

initPropertiesChangeToButton(addToCartButton);

const loadBadges = () => {
  // On load tags
  let labelContainer = document.querySelectorAll('.js-product-label-container');
  let label_text = '';
  let label_color = '';
  let getLabel = (productTag) => {
    productBadges.forEach((badge) => {
      console.log("productTag: "+productTag);

      if (badge.tag == productTag) {
        label_text = badge.title;
        label_color = badge.textColor;
      }
    });
  }

  if (labelContainer.length) {
    labelContainer.forEach(item => {
      label_text = '';
      let tags = item.dataset.tags.split(",");
      let variantQty = item.dataset.productQty;
      let hasTag = false;

      if (variantQty == 0) {
        getLabel('out-of-stock');
        label_text = 'Sold Out'
      }

      tags.forEach(tag => {
        if (tag.includes("badge|")) {
          if (!hasTag) {
            hasTag = true;
            productBadges.forEach((tag1) => {
              if (tags.includes(tag1.tag)) {
                if (label_text == 'Sold Out' || label_text == '' ) {
                  getLabel(tag1.tag);
                  return;
                }
              }
            });
          }
        }
      });
      
      if (label_text) {
        itemLabelHtml = '<span class="product-label"><span style="color: ' + label_color + ';">' + label_text + '</span></span>';
        item.innerHTML = itemLabelHtml;
      }
    });
  }
}

onload = () => {
  setTimeout(loadBadges, 1500);
  yotpo.refreshWidgets();
  getProductQuantity();
};
  
// Collection Swatch
const getProductQuantity = async (container) => {
  let availabilityCntr
  if (!container) {
    availabilityCntr = document.querySelector('.js-availability');
  } else {
    availabilityCntr = container
  }

  const checkAvailability = (qty) => {
    if (qty > 0) {
      availabilityCntr.classList.add('availability-available');
      availabilityCntr.classList.remove('availability-unavailable', 'loading');
    } else {
      availabilityCntr.classList.add('availability-unavailable');
      availabilityCntr.classList.remove('availability-available', 'loading');
    }
  }

  const loadAvailabilityClass = async (variantId, productId) => {
    const variantButtons = document.querySelectorAll('.js-variant-button');
    // const response = await fetch(`https://enel.npkn.net/c5a09c/${variantId}/${productId}`);
    const response = await fetch(`https://elephant-room.npkn.net/home-qty-api/${variantId}/${productId}`);
    const data = await response.json();

    if (!data) {
      console.error('No data returned from API in loadAvailablilityClass, variantId, productId:', { variantId, productId })
      checkAvailability(0)
      return
    }

    let thisQty = 0

    data.data.forEach((product, index) => {
        //multivariant
        if (variantButtons !== undefined && variantButtons.length > 0) {
          variantButtons[index].dataset.invQty = product.available;
          if (product.variantId == variantId) thisQty = product.available;
        }
        //Single variant
        else{
          if (product.variantId == variantId) {
            thisQty = product.available;
          }
        }
    })

    checkAvailability(thisQty);
  }

  const variantButtons = document.querySelectorAll('.js-variant-button');
  
  if (availabilityCntr !== null && availabilityCntr !== undefined) {
    const { variantId, productId } = availabilityCntr.dataset;
    await loadAvailabilityClass(variantId, productId);
  
    if (variantButtons !== null && variantButtons !== undefined) {
      variantButtons.forEach((variantButton) => {
        variantButton.addEventListener('click', async (event) => {
          availabilityCntr.classList.add('loading');
          
          if (event.target.dataset.invQty !== undefined && event.target.dataset.invQty !== null) {
            checkAvailability(event.target.dataset.invQty);
          } else {
            await loadAvailabilityClass(variantIds[event.target.dataset.variantPosition], productId)
          }
        })
      });
    }
  }
}

// Geo location popup selector

const geoPopup = document.querySelector('.js-geo-popup');
const geoLinks = document.querySelectorAll('.js-geo-popup-link');
const geoButton = document.querySelector('.js-geo-popup-btn');
const geoDropdownBtn = document.querySelector('.js-geo-popup-dropdown a');
const geoOpenPopupLink = document.querySelectorAll('.js-open-popup-loc');
const geoCloseBtn = document.querySelector('.js-popup-close-btn');
const mobileNavToggle = document.querySelector('.mobile-nav-toggle');
const mobileNavContainer = document.querySelectorAll('.mobile-navigation-drawer');

if (geoPopup !== null && geoPopup !== undefined) {
  if (sessionStorage.getItem("homebodiigeo") == null) {
    fetch('https://ipwhois.pro/?key=98gRukAqp7dFZHbD', { mode: 'cors' })
      .then((resp) => resp.json())
      .then((ip) => { 
        let isOnRegionList = geoPopupItem.some(elem => elem.countryCodes.includes(ip.country));
        let currentRegion, correctRegion, currentCountryName;
        geoPopupItem.forEach((item) => {
          if (item.url.includes(window.location.origin)) {
            currentRegion = item.region;
          }
          
          if (item.countryCodes.includes(ip.country_code)) {
            correctRegion = item.region
          }
        });
        
        if (currentRegion == undefined || currentRegion == '') currentRegion = 'Australia';

        // FIX: Set default region if no match found
        if (correctRegion == undefined || correctRegion == '') {
          correctRegion = 'Select Your Region'; // Or use currentRegion as fallback
          // Alternative: correctRegion = currentRegion; // This would default to current store's region
        }

        currentCountryName = ip.country;

        let headingHTML = geoPopup.querySelector('.js-popup-header').innerHTML.replace("[marketname]", currentRegion);
        geoPopup.querySelector('.js-popup-header').innerHTML = headingHTML;

        let subHeadingHTML = geoPopup.querySelector('.js-popup-sub-header').innerHTML.replace("[country]", "<span>"+currentCountryName+"</span>");
        geoPopup.querySelector('.js-popup-sub-header').innerHTML = subHeadingHTML;

        geoPopup.querySelector('.js-geo-popup-dropdown a').innerText = correctRegion;

        if (currentRegion !== correctRegion && sessionStorage.getItem("homebodiigeo") == null) {
          document.querySelector('body').classList.add('js-geo-popup-open');
          sessionStorage.setItem("homebodiigeo", 1);
        }

        if (geoOpenPopupLink !== null && geoOpenPopupLink !== undefined) {
          geoOpenPopupLink.forEach(link => {
            link.addEventListener('click', event => {
              event.preventDefault();
              document.querySelector('body').classList.add('js-geo-popup-open');
            });
            link.innerText = currentRegion;
          });
        }

        if (mobileNavToggle !== null && mobileNavToggle !== undefined) {
          mobileNavToggle.addEventListener('click', e => {
            document.querySelectorAll('.js-open-popup-loc').forEach(link => {
              link.addEventListener('click', event => {
                event.preventDefault();
                document.querySelector('body').classList.add('js-geo-popup-open');
              });
              link.innerText = currentRegion;
            });
          });
        }

        if (geoLinks !== null && geoLinks !== undefined) {
          geoLinks.forEach(link => {
            if (link.innerHTML == correctRegion) {
              geoButton.href = link.dataset.link;
            }
          });
        }
        
      }
    );
  }
}

if (geoLinks !== null && geoLinks !== undefined) {
  geoLinks.forEach(link => {
    link.addEventListener('click', event => {
      event.preventDefault();
      geoButton.href = event.target.dataset.link;
      geoPopup.querySelector('.js-geo-popup-dropdown a').innerText = event.target.innerText;
      geoPopup.classList.remove('js-open-dropdown');
    });
  });
  
  geoDropdownBtn.addEventListener('click', event => {
    event.preventDefault();
    
    if (geoPopup.classList.contains('js-open-dropdown')) {
      geoPopup.classList.remove('js-open-dropdown');
    } else {
      geoPopup.classList.add('js-open-dropdown');
    }
  });

  geoPopup.addEventListener('click', event => {
    if (event.target.classList.contains('geo-popup__wrapper')) {
      document.querySelector('body').classList.remove('js-geo-popup-open');     
    }
    if (geoPopup.classList.contains('js-open-dropdown') && event.target.localName !== 'a') {
      geoPopup.classList.remove('js-open-dropdown');
    }
  });

  geoCloseBtn.addEventListener('click', event => {
    event.preventDefault();
    document.querySelector('body').classList.remove('js-geo-popup-open');   
  });
}

/**
 * Creates an option element with the specified content and class name.
 * 
 * @param {string} content - The content to be displayed in the option element.
 * @param {string} [className] - The class name to be added to the option element (optional).
 * @param {string} [variantId] - The variantId to be added to the option element (optional).
 * @returns {HTMLElement} - The created option element.
 */
const createOptionElement = (content, className, variantId) => {
  const element = document.createElement('div')
  if (className) {
    element.classList.add(className)
  }
  if (variantId) {
    element.setAttribute('data-variant-id', variantId)
  }
  element.innerHTML = content
  return element
}

/**
 * Updates the mini cart options for a given variant.
 * 
 * @param {string} variantId - The ID of the variant.
 * @param {boolean} availableForDelivery - Indicates if the variant is available for delivery.
 * @param {boolean} availableForPickup - Indicates if the variant is available for pickup.
 * @param {string} deliveryCopy - The copy for the delivery option.
 * @param {string} pickupCopy - The copy for the pickup option.
 */
const updateMiniCartOptions = (variantId, availableForDelivery, availableForPickup, deliveryCopy,  pickupCopy) => {
  if (!variantId) return

  // Checks to see if that product has been added to the minicart
  const relevantMiniCartItem = document.querySelector(`#monster-upsell-cart div[data-variant-id="${variantId}"]`)
  if (!relevantMiniCartItem) return

  // Check if the delivery options have already been added to the DOM for this cart item previously
  const deliveryContent = relevantMiniCartItem.querySelector('.cart-item__availability-container')
  if (deliveryContent) {
    const contentVariantId = deliveryContent.getAttribute('data-variant-id')
    if (contentVariantId === variantId) return

    // Remove the existing delivery options from the DOM
    deliveryContent.remove()
  }

  // Creates a container for the delivery and pickup options with the relevant variantId for checking if multiple items are being added via AJAX -> where const = deliveryContent is being defined
  const deliveryOptionsContent = createOptionElement('', 'cart-item__availability-container', variantId)
  
  // For the 'Delivery' section
  const updatedDeliveryOptionContent = `${availableForDelivery ? GM_STATE.deliveryOptions.available : GM_STATE.deliveryOptions.notAvailable}`
  const updatedDeliveryOption = createOptionElement(updatedDeliveryOptionContent, 'cart-item__availability-wrap')
  updatedDeliveryOption.innerHTML = updatedDeliveryOption.innerHTML.replace('{delivery_copy}', deliveryCopy)

  // For the 'Pickup' section
  const pickupOptionsContentInnerContent = `${availableForPickup ? GM_STATE.deliveryOptions.available : GM_STATE.deliveryOptions.notAvailable}`
  const updatedPickupOptionContent = pickupOptionsContentInnerContent.replace('{delivery_copy}', pickupCopy)
  const updatedPickupOption = createOptionElement(updatedPickupOptionContent, 'cart-item__availability-wrap')

  // Adding the updated delivery and pickup options to the DOM
  deliveryOptionsContent.appendChild(updatedDeliveryOption)
  deliveryOptionsContent.appendChild(updatedPickupOption)
  relevantMiniCartItem.appendChild(deliveryOptionsContent)
}

/**
 * Updates the mini cart with delivery and pickup options for each cart item.
 */
const updateMiniCartDelivery = async () => {
  let cartItems = []

  try {
    const response = await fetch('/cart.js')
    const cart = await response.json()
    cartItems = cart.items
  } catch (err) {
    console.error('Could not fetch cart data in updateMiniCartDelivery', err)
    return null
  }

  if (!cartItems.length) return

  for (const cartItem of cartItems) {
    // Iterates through each item and just continues if specific cartItem doesn't have the relevant properties to avoid errors
    if (!cartItem.properties['Delivery Availability'] || !cartItem.properties['Pickup Availability']) {
      console.log('This item does not have any delivery or pickup properties. Cart Item:', cartItem)
      continue
    }

    const variantId = cartItem.id
    const availableForDelivery = cartItem.properties['Delivery Availability'].includes('Not') ? false : true
    const availableForPickup = cartItem.properties['Pickup Availability'].includes('unavailable') ? false : true
    const deliveryCopy = cartItem.properties['Delivery Availability']
    const pickupCopy = cartItem.properties['Pickup Availability']

    updateMiniCartOptions(variantId, availableForDelivery, availableForPickup, deliveryCopy,  pickupCopy)
  }
}

const bodyNode = document.querySelector('body');

// This is to listen for when minicart is opened and closed to update the delivery options
const styleChangeCallback = (mutations) => {
  for (const mutation of mutations) {
    if (mutation.attributeName === 'style') {
      updateMiniCartDelivery();
    }
  }
};

const styleChangeObserver = new MutationObserver(styleChangeCallback);

// This is to listen for when minicart items have been removed so re-render the correct delivery options
const observeMiniCart = () => {

  // debugger;
  const monsterUpsellCart = document.querySelector('#monster-upsell-cart');

  const miniCartObserverConfig = {
    childList: true,
    subtree: true,
  };

  const miniCartCallback = (mutations) => {
    for (const mutation of mutations) {
      if (mutation.target.id === 'mu-items-container') {
        updateMiniCartDelivery();
      }
    }
  };

  const miniCartObserver = new MutationObserver(miniCartCallback);
  miniCartObserver.observe(monsterUpsellCart, miniCartObserverConfig);
};

// Used to init observeMiniCart, watches for when MonsterUpsell 3rd Party app initializes the minicart into DOM
const monsterUpsellObserverCallback = (mutations) => {
  for (const mutation of mutations) {
    const monsterUpsellCartAdded = Array.from(mutation.addedNodes).some(
      (node) => node.id === 'monster-upsell-cart'
    );

    if (mutation.type === 'childList' && monsterUpsellCartAdded) {
      observeMiniCart();
      monsterUpsellObserver.disconnect();
    }
  }
};

const monsterUpsellObserver = new MutationObserver(monsterUpsellObserverCallback);

window.addEventListener('DOMContentLoaded', () => {
  styleChangeObserver.observe(bodyNode, { attributes: true, attributeFilter: ['style'] });
  monsterUpsellObserver.observe(bodyNode, { childList: true, subtree: true });
});



document.querySelector('body').addEventListener('click', (event) => {
  if(event.target.classList.contains('variant_item') && event.target.closest('.quick_buy_container')){
    if(event.target.classList.contains('in_stock')){
          event.target.closest('.quick_buy_container').querySelector('.selected').classList.remove('selected');
        event.target.classList.add('selected');
    }

  }

})
document.querySelector('body').addEventListener('click', (event) => {
  var productID = '';
  if(event.target.classList.contains('js-add-to-cart-button_quickbuy')){
    
    productID = event.target.closest('.quick_buy_container').querySelector('.selected').getAttribute('data-variant_id');
    addtocart(productID)
  }else if(event.target.classList.contains('js-add-to-cart-button_quickbuy_mobile') || event.target.closest('.js-add-to-cart-button_quickbuy_mobile') ){
    // productID = event.target.classList.contains('js-add-to-cart-button_quickbuy_mobile')  ? event.target.getAttribute('data-variant_id') : 
      event.target.closest('.quick_buy_container').classList.add('is-open');
      // var button_quickbuy_mobile = event.target.classList.contains('js-add-to-cart-button_quickbuy_mobile') ? event.target.classList.contains('js-add-to-cart-button_quickbuy_mobile') : event.target.closest('.js-add-to-cart-button_quickbuy_mobile')
      // button_quickbuy_mobile.style.display = 'none';
  }

  if(event.target.closest('.pair-with')){
    console.log(event.target);
    if(event.target.closest('.add-to-cart') || event.target.classList.contains('add-to-cart')){
      event.preventDefault();
        productID = event.target.closest('form').querySelector('select').value;
        if(productID && productID !== 'SELECT SIZE'){
        addtocart(productID)
      }
  
    }
  }
  function addtocart(productID){
    if(productID){
          let formData = {
          'items': [{
            'id': productID,
            'quantity': 1 
            }]
          };
        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        })
        .then(response => {
          return response.json();
        })
        .then(() => {
          document.documentElement.dispatchEvent(new CustomEvent('theme:cartchanged', { bubbles: true, cancelable: false, detail: { openDrawer: true } }));
          // window.monster_refresh()
  
        })
        .catch((error) => {
          console.error('Error:', error);
        });
    }
  }
    
});

$(document).on("click", function (event) {
    if (!$(event.target).closest(".quick_buy_container.is-open").length) {
        $(".is-open").removeClass("is-open");
    }
});

// buy now button
if(document.querySelector('#buy_now_button')){
  
document.querySelector('#buy_now_button').addEventListener('click', (event) => {
  var productVariantId = document.querySelector('.buy-buttons-row form select[name="id"]').value;
  var quantity = document.querySelector('.buy-buttons-row form #quantity').value;
  buyNow(productVariantId, quantity);
  function buyNow(productVariantId, quantity = 1) {
      fetch(`/cart/add.js`, {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json'
          },
          body: JSON.stringify({
              id: productVariantId,
              quantity: quantity
          })
      })
      .then(response => response.json())
      .then(data => {
          window.location.href = '/checkout'; // Redirect to checkout after adding
      })
      .catch(error => console.error('Error:', error));
  }
})
}

//flickity 
if(document.querySelectorAll('.pair-with .product-list')){
  
  var elems = document.querySelectorAll('.pair-with .product-list:not(.carousel)');
  elems.forEach(elem=>{
      var flkty = new Flickity( elem, {
        // options
        cellAlign: 'left',
        contain: true,
        prevNextButtons: true,
        pageDots:false
        
      });
    
      // element argument can be a selector string
      //   for an individual element
      var flkty = new Flickity( '.product-list', {
        // options
      });
  })

}
document.addEventListener("click", function (e) {
  // Apply Discount button
  const applyBtn = e.target.closest("#apply-discount");
  if (applyBtn) {
    const discountCodeInput = document.getElementById("discount-code");
    const discountCode = discountCodeInput?.value.trim();

    if (!discountCode) {
      document.getElementById("discount-message").textContent = "Please enter a discount code.";
      return;
    }

    fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        attributes: { discount_code: discountCode },
      }),
    })
      .then((response) => response.json())
      .then(() => {
        document.getElementById("discount-message").textContent = "Discount code saved!";
        document.dispatchEvent(
          new CustomEvent("theme:cartchanged", { bubbles: true, cancelable: false })
        );
      })
      .catch((error) => {
        console.error("Error applying discount:", error);
        document.getElementById("discount-message").textContent = "Error applying discount.";
      });

    return; // prevent fallthrough to next block
  }

  // Toggle Discount Section
  const wrapper = e.target.closest(".discount-wrapper");
  if (wrapper) {
    const container = wrapper.closest(".discount-container");
    const section = container?.querySelector(".discount-section");

    if (wrapper.getAttribute("data-state") === "open") {
      section.style.display = "flex";
      wrapper.setAttribute("data-state", "close");
      wrapper.querySelector("span").innerText = "Close";
    } else {
      section.style.display = "none";
      wrapper.setAttribute("data-state", "open");
      wrapper.querySelector("span").innerText = "Apply Coupon Code";
    }
  }
});


// Insurance Add/Remove from Cart
const insuranceCheckbox = document.querySelector("input.shipping-switch-input");

if (insuranceCheckbox) {
    const insurance_id = insuranceCheckbox.value;

    insuranceCheckbox.addEventListener("change", (event) => {
        event.preventDefault(); // ✅ Prevent default behavior
        if (!insurance_id) {
            console.error("Error: Insurance product ID is missing.");
            return;
        }
        // Disable checkbox while fetching
        insuranceCheckbox.disabled = true;

        const url = insuranceCheckbox.checked ? "/cart/add.js" : "/cart/change.js";
        const bodyData = insuranceCheckbox.checked 
            ? { id: insurance_id, quantity: 1 } 
            : { id: insurance_id, quantity: 0 };

        fetch(url, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(bodyData)
        })
        .then(response => response.json())
        .then((data) => {
            debugger;
            // Refresh cart areas
            document.documentElement.dispatchEvent(
                new CustomEvent('theme:cartchanged', { bubbles: true, cancelable: false })
            );
        })
        .catch(error => console.error("Error:", error))
        .finally(() => {
            // Re-enable checkbox after request completes
            insuranceCheckbox.disabled = false;
        });
    });
}
